<template>
    <div class="page">
        <Calendar class="historyModel" :allInfo="allInfo" :calendarData="calendarData" :bannarUrl="bannarUrl"
                  :desc="allInfo.prizeCurrent?.desc" :isActivityEnd="isActivityEnd"/>
      <div class="center-prompt" v-if="cycle && consumption">
        <img mode="widthFix" src="../../../assets/pointsActivity/prompt.png">
        <div class="prompt-tip">
          <div class="left">
            <div>{{ allInfo.prizeCurrent?.orderGuidance.title }}</div>
            <div>{{ Product }}</div>
          </div>
          <div class="right" @click="toPage(orderBtn.url)">
            {{ orderBtn.title }}
            <img src="../../../assets/pointsActivity/quheyibei@2x.png">
          </div>
        </div>
      </div>
      <div class="buttom-goods" v-if="isShowAvailablePoints && token !== undefined">
        <div class="prize">
          <div class="left-title">
            <img src="../../../assets/pointsActivity/ustart-pic.png">
            <div class="titsty">您的星值</div>
          </div>
        </div>
        <div class="integral">
          <div class="balance">
            <div class="num">
              {{ pointsRemaining }}<img src="../../../assets/pointsActivity/xingxing@2x.png">
            </div>
            <div class="text" v-html="AvailablePoints"></div>
          </div>
          <div class="tip">
            本期已获得
            <span>{{ allInfo.prizePoints ? allInfo.prizePoints.points : 0 }}</span>
            <img src="../../../assets/pointsActivity/xingxing@2x.png">
          </div>
        </div>
      </div>
      <div class="buttom-goods"
           v-if="(allInfo?.prizePoints?.winningStatus==1 && WinningLotteryData.length > 0) || prizeData.length>0">
        <div class="prize" v-if="allInfo?.prizePoints?.winningStatus==1 && WinningLotteryData.length > 0">
          <div class="left-title">
            <img src="../../../assets/pointsActivity/winningIcon.png">
            我中奖的
          </div>
        </div>
        <Winning v-if="allInfo?.prizePoints?.winningStatus==1" :WinningLotteryData="WinningLotteryData"/>
        <div class="prize" v-if="prizeData.length>0">
          <div class="left-title">
            <img class="exchange-icon" src="../../../assets/pointsActivity/exchangeIcon.png">
            <div class="meexchange">我兑换的</div>
          </div>
        </div>
        <Exchange :prizeData="prizeData" :prizeDataLength="allInfo.prizeCurrent?.templates.length"
                  :linkTerminal="linkTerminal"/>
      </div>
      <div class="buttom-goods" v-if="showLotteryDraw">
        <div class="prize">
          <div class="left-title">
            <img src="../../../assets/pointsActivity/card.png">
            <div class="titsty-start">星值抽奖</div>
            <div class="text" v-if="luckDrawState===0 && !winningCode">
              累计获得<span>{{ allInfo.prizeCurrent?.luckyDraw.requiredPoints }}</span>
              <img src="../../../assets/pointsActivity/xingxing@2x.png">即可参与抽奖
            </div>
          </div>
          <div class="more" @click="lotteryDraw('0')" v-if="drawPicUrl">抽奖说明<img
              src="../../../assets/pointsActivity/rightmore.png" mode="widthFix"/></div>
        </div>
        <div class="luckyDraw">
          <img :src="drawPicUrl" mode="widthFix" @click="lotteryDraw('1')"/>
          <div v-if="luckDrawState===2 && (allInfo.prizePoints?.prizeCode === 0 || allInfo.prizePoints == null)"
               class="lottery-part">
            <div class="lottery-btn disable">
              <span class="text">抽奖已结束</span>
            </div>
          </div>
           <div v-else-if="token == undefined" class="logout">
              <button class="login-button" @click="toPage(orderBtn.url)">参与抽奖</button>
            </div>
          <div v-else-if="luckDrawState===0 && !winningCode" class="notSatisfied">您的星值暂时不够解锁抽奖哦～</div>
          <template v-else>
            <div class="lottery-part no-padding" v-if="winningCode && allInfo.prizePoints.prizeStatus == 1">
              <!-- 此处3个状态，一个待开奖，后面中奖和未中奖，需要替换背景图片，以及 ticket-code 加class： winning -> 中奖， losing -> 未中奖-->
              <!--待开奖-->
              <img v-if="prizeStatus==1" class="bg-ticket" src="@/assets/pointsActivity/bg_awaiting.png" alt="">
              <div v-if="prizeStatus==1" class="ticket-code normal">{{ allInfo.prizePoints.prizeCode }}</div>
              <!--中奖-->
              <img v-if="prizeStatus==3" class="bg-ticket" src="@/assets/pointsActivity/bg_winning.png" alt="">
              <div v-if="prizeStatus==3" class="ticket-code normal winning">{{ allInfo.prizePoints.prizeCode }}</div>
              <!--未中奖-->
              <img v-if="prizeStatus==2" class="bg-ticket" src="@/assets/pointsActivity/bg_losing.png" alt="">
              <div v-if="prizeStatus==2" class="ticket-code normal losing">{{ allInfo.prizePoints.prizeCode }}</div>
            </div>
            <div v-else class="lottery-part">
              <div class="lottery-btn" :class="{'disable':btnLoading}" @click="applyLottery">
                <span class="icon" v-if="btnLoading">
                  <img src="@/assets/pointsActivity/btn_loading.gif" alt="加载中">
                </span>
                <span class="text" v-else>参与抽奖</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="buttom-goods">
        <div class="prize">
          <div class="left-title textFlex">
            <div><img src="../../../assets/pointsActivity/bianzu9@2x.png"></div>
            <div>兑换好礼</div>
            <div class="text">消耗对应星值 兑换限定周边</div>
          </div>
        </div>
        <div class="line" v-if="todaytime < new Date('2023/06/10 00:00:00').getTime()">
          <span></span>
          <div>6月10日开启兑换</div>
          <span></span>
        </div>
        <Prize @getExchange="getExchange" :exchangeStatus="exchangeStatus" :isLogin="true"
               :prizeList="allInfo.prizeCurrent?.templates || []"/>
      </div>
        <CottiModal :show="modalStatus" :title="modal.title" :desc="modal.desc" :btn-text="modal.btn"
                    @onConfirm="()=>{this.modalStatus=false}" @onClose="()=>{this.modalStatus=false}">
          <slot>
            <div class="lottery-ticket">
              <div class="code">{{ winningCode }}</div>
            </div>
          </slot>
        </CottiModal>
        <CottiModal :show="exchangeModalStatus" :title="exchangeModal.title" :desc="exchangeModal.desc"
                    :btn-text="exchangeModal.btn"
                    @onConfirm="confirmExchange" @onClose="()=>{this.exchangeModalStatus=false}">
          <slot>
            <div class="lottery-Exchang">
              <div class="top">
                <div>您正在使用</div>
                <span>{{ validateData.points }}</span>
                <img src="../../../assets/pointsActivity/xingxing@2x.png">
                <div>兑换</div>
              </div>
              <div class="down">
                {{ validateData.prizeName }}
              </div>
            </div>
          </slot>
        </CottiModal>
        <CottiModal :show="winningDialog" :imgContent="true"
                    @onClose="()=>{this.winningDialog=false;this.winningFalsh = false}">
          <slot>
            <img :src="winningDialogImg" class="adImgSize">
            <div class="bottom-gif" v-if="winningFalsh">
              <img src="../../../assets/pointsActivity/winningAnimation.gif">
            </div>
          </slot>
        </CottiModal>
      </div>
</template>

<script>
import Prize from "@/views/pointsActivity/components/prize";
import CottiModal from '../components/modal'
import {
  getDialogAdInfo,
  getExchangeData,
  getHistory,
  getPointsActivityInfo,
  getPointsDetails,
  getValidateData,
  prizeList,
  submitLotteryWish,
  updateFrequency
} from "@/api/pointsActivity";
import Winning from "@/views/pointsActivity/components/winning";
import Exchange from "@/views/pointsActivity/components/exchange";
import Calendar from "@/views/pointsActivity/components/calendar";
import wx from "weixin-js-sdk";

export default {
  name: "history",
  components: {Prize, Winning, Exchange, CottiModal, Calendar},
  props: {
    activityNoHistory: {
      type: String,
      default:undefined
    },
  },
  watch:{
    activityNoHistory(val){
      this.activityNo = val
    }
  },
  data() {
    return {
      historyData: [],
      //日历数据
      calendarData: [],
      winningDialog: false,
      winningFalsh: false,
      winningDialogImg: '',
      WinningLotteryData: [],
      // 中奖数据存放
      prizeData: [],
      // 是否能兑换
      exchangeStatus: false,
      bannarUrl: '',
      drawPicUrl: null,
      winningCode: null,
      luckDrawState: 0, // 0 没有资格，1有资格
      // 是否展示抽奖部分
      showLotteryDraw: undefined,
      endtime: undefined,  //活动结束时间
      todaytime: undefined,  //当前时间
      // 未使用积分
      pointsRemaining: 0,
      // 是否显示积分栏
      isShowAvailablePoints: true,
      // 引导文案可用积分栏
      AvailablePoints: '',
      // 判断下单引导栏下单按钮
      orderBtn: '',
      // 判断下单引导栏
      Product: '',
      // 判断是否当前活动积分周期
      cycle: false,
      // 判断当天未完成消费积分
      consumption: false,
      linkTerminal: undefined,
      memberId: 0,
      memberMobile: undefined,
      activityNo: undefined,
      popupVisible: false,
      allInfo: {},
      isLoading: false,
      token: undefined,
      btnLoading: false,
      modalStatus: false,
      modal: {
        title: '参与抽奖成功',
        desc: '',
        btn: '我知道了',
      },
      exchangeModalStatus: false,
      exchangeModal: {
        title: '兑换确认',
        desc: '',
        btn: '确认兑换',
      },
      validateData: {},
      currentItem: {},
      prizeStatus: -1,
      //活动是否结束
      isActivityEnd:false
    }
  },
  async mounted() {
    let {linkTerminal, memberId, contact_id, u_t} = this.$route.query
    if (contact_id !== undefined || memberId !== undefined) {
      this.memberId = !u_t ? (linkTerminal == 3 ? memberId : linkTerminal == 2 ? contact_id : (contact_id || memberId)) : undefined
    }
    this.token = u_t
    this.linkTerminal = linkTerminal
    this.activityNo = this.activityNoHistory
    await this.getInfo()
    await this.getHistoryList()
  },
  methods: {
    async getInfo() {
      let {memberId, activityNo, token} = this
      this.isLoading = true;
      this.exchangeStatus = false
      await getPointsActivityInfo({memberId, activityNo}, {token}).then((res) => {
        if (res.code == 200) {
          this.allInfo = res.data

          /* 我中奖的 */
          if (res.data.prizePoints?.winningStatus == 1) {
            this.WinningLotteryData = res.data.prizeCurrent.luckyDraw.lotteryPrizes.filter(f => f.prizeType == res.data.prizePoints.winningType)
          }

          //获取我兑换的奖品
          this.getPrizeData()

          /*  判断是否当前活动积分周期  */
          let date = new Date();
          let startTime = Date.parse(new Date(res.data.prizeCurrent.pointsStartTime.replaceAll("-", "/")).toString());    // 活动开始时间
          let endTime = Date.parse(new Date(res.data.prizeCurrent.pointsEndTime.replaceAll("-", "/")).toString());       // 活动结束时间
          let currentTime = date.getTime()  //当前时间
          if (currentTime <= endTime && currentTime >= startTime) {
            this.cycle = true
          }

          let activityEndTime = Date.parse(new Date(res.data.prizeCurrent.activityEndTime.replaceAll("-", "/")).toString());
          if(currentTime > activityEndTime){
            this.isActivityEnd = true
          }

          getPointsDetails({memberId, activityNo}, {token}).then(detail => {
            this.calendarData = detail.data || []
            /*  判断当天未完成消费积分 */
            let today = date.toLocaleDateString('zh', {
              year: 'numeric', month: '2-digit',
              day: '2-digit'
            })  // 获取当天日期
            let todayConsumption = detail.data.filter(item => item.orderTime.replaceAll("-", "/").split(" ")[0] == today)   //过滤数组 获取当前日期
            if (todayConsumption && todayConsumption.length > 0) {
              this.consumption = todayConsumption[0].points == 0 ? true : false
            }
            if (detail.data.length <= 0) {
              this.consumption = false
            }
          })


          /*  下单引导栏  */
          let isAllProduct = res.data.prizeCurrent.isAllProduct  //商品
          let shopNotInRules = res.data.prizeCurrent.shopNotInRules   //门店
          if (isAllProduct && shopNotInRules.length <= 0) {
            //任意门店消费任意商品即可攒星
            this.Product = res.data.prizeCurrent.orderGuidance.content.noShopAndProduct
          } else if (isAllProduct && shopNotInRules.length > 0) {
            //指定门店消费任意商品即可攒星
            this.Product = res.data.prizeCurrent.orderGuidance.content.shopAndProduct
          } else if (!isAllProduct && shopNotInRules.length <= 0) {
            //任意门店消费指定商品即可攒星
            this.Product = res.data.prizeCurrent.orderGuidance.content.noShopAndNoProduct
          } else if (!isAllProduct && shopNotInRules.length > 0) {
            //指定门店消费指定商品即可攒星
            this.Product = res.data.prizeCurrent.orderGuidance.content.shopAndNoProduct
          }

          /*  下单引导栏按钮  */
          if (this.token == undefined || this.token == null || this.token == '') {
            this.isLogin = false
            // undefined 是用户未登录状态小程序
            this.Product = '登录后可查看攒星详情及兑换周边'
            this.allInfo.prizeCurrent.orderGuidance.title = '您尚未登录'
            if (this.linkTerminal == 3) {
              this.orderBtn = {
                title: '立即登录',
                url: ''
              }
            } else {
              this.orderBtn = {
                title: '立即登录',
                url: 'packages/common/login/index'
              }
            }
          } else {
             if (this.linkTerminal == 3) {
              this.orderBtn.title = res.data.prizeCurrent?.orderGuidance.button.app.title
              this.orderBtn.url = res.data.prizeCurrent?.orderGuidance.button.app.url
            } else {
              this.orderBtn.title = res.data.prizeCurrent?.orderGuidance.button.wechat.title
              this.orderBtn.url = res.data.prizeCurrent?.orderGuidance.button.wechat.url
            }
          }

          /* 抽奖内容 */
          this.showLotteryDraw = res.data.prizeCurrent.luckyDraw.status
          this.winningCode = res.data.prizePoints?.prizeCode | ''
          this.luckDrawState = res.data.luckDrawState;
          this.drawPicUrl = res.data.prizeCurrent.luckyDraw.adInfo?.pictureUrl || res.data.prizeCurrent.luckyDraw.adInfo?.conditionMap.positionResourceFile1[0].value
          this.bannarUrl = res.data.prizeCurrent.defaultBanner.adInfo?.pictureUrl || res.data.prizeCurrent.defaultBanner.adInfo?.conditionMap.positionResourceFile1[0].value

          /* 判断抽奖状态展示 */
          if (res.data.prizeCurrent.luckyDraw && res.data.prizeCurrent.luckyDraw.status) {
            if (res.data.prizePoints) {
              this.getLuckyDrawStatus(res.data.prizePoints);
            }
          }

          /*  引导文案可用积分栏  */
          let minPoints = res.data.minPoints       //最小梯度奖品积分
          this.pointsRemaining = res.data.prizePoints ? res.data.prizePoints?.pointsRemaining || 0 : 0    //未使用积分数值
          let temporarily = minPoints - this.pointsRemaining    //未使用积分数值
          this.endtime = new Date(res.data.prizeCurrent.activityEndTime.replaceAll("-", "/")).getTime()   //活动结束时间
          let pointsStartTime = new Date(res.data.prizeCurrent.pointsEndTime.replaceAll("-", "/")).getTime()   //积分结束时间
          this.todaytime = new Date().getTime()      //当前时间


          if (minPoints > this.pointsRemaining && this.todaytime <= pointsStartTime) {
            this.AvailablePoints = `再消费 <span>${temporarily}</span> 杯即可兑换库迪周边`
          } else if (this.todaytime <= this.endtime && this.pointsRemaining >= minPoints) {
            let activittime = res.data.prizeCurrent.activityEndTime.split(" ")[0]
            let endYear = new Date(activittime).getFullYear()
            if (new Date().getFullYear() == endYear) {
              activittime = activittime.split("-").slice(1, 3).join("-")
            }
            this.AvailablePoints = `请于 <span>${activittime}</span> 前兑换使用`
            this.exchangeStatus = true
          } else if (this.todaytime > this.endtime && this.pointsRemaining > 0) {
            this.AvailablePoints = '过期未使用'
          } else if (this.todaytime > this.endtime && this.pointsRemaining == 0) {
            this.isShowAvailablePoints = false
          } else {
            this.AvailablePoints = ''
          }
          if (this.allInfo.prizePoints != null
              && this.allInfo.prizePoints.winningStatus == 1
              && this.allInfo.prizeCurrent != null
              && this.allInfo.prizeCurrent.luckyDraw != null
              && this.allInfo.prizeCurrent.luckyDraw.status) {
            let luckyDrawTypes = this.allInfo.prizeCurrent.luckyDraw.lotteryPrizes.filter(f => f.prizeType == this.allInfo.prizePoints.winningType);
            this.getDialogAdDetail(`draw_win_${this.allInfo.prizePoints.memberId}_${this.allInfo.prizeCurrent.no}`, luckyDrawTypes[0].winningPopupAd)
          }
        }
      }).finally(() => {
        this.isLoading = false;
      })
    },
    async getDialogAdDetail(did, code) {
      await getDialogAdInfo({
        did,
        code,
        viewPage: 'cotti-app-home'
      }).then(res => {
        if (res.code == 200 && res.data.length > 0) {
          let adInfo = res.data[0]
          this.winningDialogImg = adInfo.url
          this.winningDialog = true
          this.winningFalsh = true
          setTimeout(() => {
            this.winningFalsh = false
          }, 2000)
          updateFrequency({
            did,
            code,
            positionCode: adInfo.positionCode
          })
        }
      })
    },
    getLuckyDrawStatus(userPoint) {
      if (userPoint) {
        let {prizeStatus, prizeCode, winningStatus} = userPoint
        //未参与抽奖
        if (prizeStatus == 0 || prizeStatus == null) {
          this.prizeStatus = 0
        } else if (winningStatus == 1) {
          //中奖
          this.prizeStatus = 3
        } else if (prizeStatus == 1 && prizeCode != null && this.luckDrawState != 2) {
          //待抽奖
          this.prizeStatus = 1
        } else if ((winningStatus == 0 || winningStatus == null) && prizeStatus == 1 && this.luckDrawState == 2) {
          //未中奖
          this.prizeStatus = 2
        }
      }
    },
    async applyLottery() {
      if (this.btnLoading) {
        return
      }
      try {
        this.btnLoading = true
        let {memberId, token} = this
        const res = await submitLotteryWish({
          activityId: this.allInfo?.prizeCurrent?.id,
          memberId
        }, {token})
        if (res.code == 200) {
          this.winningCode = res.data.prizeCode
          if (res.data.msg) {
            this.modalStatus = true
            this.$set(this.modal, 'desc', res.data.msg)
            this.allInfo.prizePoints.prizeCode = this.winningCode
          }
        }
        console.log('submitLotteryWish', res)
      } catch (e) {
        console.warn('submitLotteryWish error', e)
      } finally {
        this.btnLoading = false
      }
    },
    async getPrizeData() {
      let {memberId, token} = this
      let activityId = this.allInfo?.prizeCurrent?.id
      let adPrefix = this.allInfo?.prizeCurrent?.adPrefix
      prizeList({memberId, activityId, adPrefix}, {token}).then((res) => {
        if (res.code == 200) {
          this.prizeData = res.data ? res.data : [];
        }
      })
    },
    async getHistoryList() {
      let activityNo = this.allInfo.prizeCurrent.no
      let memberId = this.memberId
      getHistory({activityNo, memberId}).then((res) => {
        if (res.code == 200) {
          this.historyData = res.data
        }
      })
    },
    getExchange(item) {
      if (this.pointsRemaining < item.requiredPoints) {
        this.$toast('星值不足，再攒攒吧~');
      } else if (this.todaytime > this.endtime) {
        this.$toast('已过兑换截止时间');
      } else if (this.pointsRemaining >= item.requiredPoints) {
        if (this.todaytime < new Date('2023/06/10 00:00:00').getTime()) {
          this.$toast('6月10日开启兑换哦');
        } else {
          this.currentItem = item
          let activityNo = this.allInfo.prizeCurrent.no
          getValidateData({activityNo, templateNo: item.templateNo}).then((res) => {
            this.exchangeModalStatus = true
            if (res.code == 200 && res.busCode == 1) {
              this.validateData = res.data
              this.exchangeModal.desc = `兑换成功后，您的账户将到账 1 张「${res.data.couponName}」`
            } else {
              this.exchangeModalStatus = false
              this.$toast(res.busMessage)
            }
          })
        }
      }
    },
    toPage(url) {
      if (this.linkTerminal == 3) {
        if (this.token == undefined || this.token == null || this.token == '') {
          try {
            const data = ''
            NavigationLogin.postMessage(data)
          } catch (e) {
            console.warn('NavigationLogin is error')
            console.warn(e)
          }
        } else {
          const data = `{"path":"${url}"}`;
          CottiNavigation.postMessage(data);
        }
      } else if (this.linkTerminal == 2 || this.linkTerminal == undefined) {
        wx.miniProgram.navigateTo({
          url: `/${url}`,
        });
      }
    },
    confirmExchange() {
      let activityNo = this.allInfo.prizeCurrent.no
      let templateNo = this.currentItem.templateNo
      let identification = this.validateData.identification
      getExchangeData({activityNo, templateNo, identification}).then((res) => {
        if (res.code == 200 && res.busCode == 1) {
          this.$toast.success('兑换成功')
          this.exchangeModalStatus = false
          this.getInfo()
        } else {
          this.$toast(res.busMessage)
          this.getInfo()
        }
      })
    },
    toHistoryDetail(val) {
      console.log(val)
    },
    lotteryDraw() {
      if (this.linkTerminal == 3) {
        const data = `{"path":"${this.allInfo.prizeCurrent.luckyDraw.adInfo.conditionMap.url_3_1[0].value}"}`;
        CottiNavigation.postMessage(data);
      } else if (this.linkTerminal == 2 || this.linkTerminal == undefined) {
        wx.miniProgram.navigateTo({
          url: `/${this.allInfo.prizeCurrent.luckyDraw.adInfo.conditionMap.url_4_1[0].value}`,
        });
      }
    },
    openModal() {
      this.popupVisible = true
    },
    hidePopup() {
      this.popupVisible = false
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/font/D-DIN-PRO/dDinPro500.css";

.bottom-gif {
  width: 100%;
  height: auto;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

.page {
  width: 100%;
  padding-bottom: 84px;
  background: #F5F6F7;
  position: relative;
  border-radius: 8px 8px 0 0;
  padding-top: 96px;

  .top-poster {
    position: relative;
    width: 100%;

    .banner {
      width: 100%;
      display: block;
    }

    .activity {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 48px;
      right: 40px;
      width: 148px;
      line-height: 48px;
      color: #fff;
      font-size: 20px;
      text-align: center;
      border-radius: 28px;
      background: rgba(58, 59, 60, 0.3);

      img {
        width: 22px;
        height: 22px;
        margin-right: 4px;
      }
    }

  }

  .center-prompt {
    position: relative;
    width: calc(100% - 48px);
    margin: 24px auto;
    margin-bottom: 0;
    top: 0;
    left: 0;

    img {
      display: block;
      width: 100%;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
    }

    .prompt-tip {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      top: 0;
      left: 0;
      padding: 24px;
      width: calc(100% - 48px);
      height: calc(100% - 48px);

      .left {
        color: #FFFFFF;
        //font-family: PingFangSC-Medium, PingFang SC;

        div:first-child {
          font-size: 30px;
          font-weight: 500;
        }

        div:last-child {
          font-size: 22px;
          margin-top: 8px;
          font-weight: 500;
        }
      }

      .right {
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 24px;
        font-weight: 500;

        img {
          width: 24px;
          height: 24px;
          margin-left: 10px;
        }
      }
    }

  }

  .buttom-goods {
    width: calc(100% - 96px);
    margin: auto;
    margin-top: 24px;
    padding: 24px;
    background: #FFFFFF;
    border-radius: 8px;

    .integral {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .balance {
        display: flex;
        flex-flow: wrap;
        flex: 1;
        align-items: baseline;
        font-size: 24px;
        line-height: 50px;
        color: #3C3C3C;
        //height: 56px;

        .num {
          position: relative;
          font-family: "D-DIN-PRO-500-Medium";
          font-size: 56px;
          color: #A52337;
          padding-right: 48px;

          img {
            position: absolute;
            vertical-align: bottom;
            width: 32px;
            height: 32px;
            margin-left: 6px;
            bottom: 2px;
          }
        }

        .text {
          display: flex;
          align-items: flex-end;
          font-size: 22px;
          color: #5E5E5E;
          font-weight: 500;
          font-family: "D-DIN-PRO-500-Medium";

          ::v-deep span {
            color: #A52337;
            font-size: 28px;
            margin: 0 4px 1px 4px;
          }
        }
      }

    }

    .line {
      display: flex;
      align-items: center;
      font-weight: 500;
      color: #5E5E5E;
      font-size: 24px;
      width: 100%;
      margin: 8px 0 32px 0;

      div {
        font-weight: bold;
        color: #5E5E5E;
      }

      span {
        flex: 1;
        color: #EEEEEE;
        width: 50%;
        height: 1px;
        background: #EEEEEE;
      }

      div {
        margin: 0 24px;
      }
    }

    .prize {
      display: flex;
      align-items: center;
      font-size: 24px;
      font-weight: 500;
      color: #3A3B3C;
      margin: 8px 0 32px 0;
      justify-content: space-between;

      img {
        width: 32px;
        height: 32px;
        margin-right: 4px;
        vertical-align: text-bottom;
      }

      .text {
        font-size: 22px;
        color: #5E5E5E;
        margin-left: 8px;

        ::v-deep span {
          color: #A52337;
          font-size: 28px;
        }
      }

      .left-title {
        display: flex;
        font-size: 28px;
        align-items: center;
        font-family: "D-DIN-PRO-500-Medium";

        span {
          margin: 0 4px;
        }

        .meexchange {
          margin: 5px 0 0 4px;
        }

        .exchange-icon {
          width: 26px;
          height: 26px;
        }

        .titsty {
          margin-top: 3px;
        }

        .titsty-start{
          margin-top: 2px;
        }
      }

      .textFlex {
        align-items: flex-end;
      }

      .more {
        display: flex;
        align-items: center;
        color: #5E5E5E;
        font-size: 24px;

        img {
          width: 32px;
        }
      }
    }

    .tip {
      color: #3A3B3C;
      padding: 0 20px;
      height: 56px;
      line-height: 56px;
      text-align: center;
      font-size: 22px;
      font-weight: 500;
      background: #F5F6F7;
      border-radius: 28px;
      font-family: "D-DIN-PRO-500-Medium";

      span {
        font-size: 28px;
        color: #A52337;
        margin: 0 4px;
      }

      img {
        vertical-align: sub;
        width: 32px;
        height: 32px;
      }
    }

    .luckyDraw {
      width: 100%;
      margin-top: 8px;

      img {
        border-radius: 8px 8px 0 0;
        width: 100%;
        height: auto;
        display: block;
      }

      .notSatisfied {
        width: 100%;
        height: 108px;
        line-height: 108px;
        text-align: center;
        font-size: 32px;
        color: #979797;
        font-weight: 500;
        background: #F5F6F7;
        border-radius: 0 0 8px 8px;
      }

      .logout {
        text-align: center;
        margin-top: 40px;
        .login-button {
          width: 272px;
          height: 96px;
          background: linear-gradient(90deg, #F25757 0%, #A52337 100%);
          box-shadow: 0px 24px 48px 0px #FFB1B11F;
          border-radius: 62px;
          border-color: #FFFFFF;
          border: none !important;
          font-size: 36px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 50px;
        }
      }

      .lotteryCode {
        width: 100%;
        text-align: center;
        font-size: 32px;
        color: #979797;
        font-weight: 500;
        background: #F5F6F7;
        border-radius: 0 0 8px 8px;
        padding-bottom: 40px;

        .text {
          padding: 24px 0;
        }

        .cardbox {
          width: 100%;
          position: relative;

          img {
            display: block;
            margin: auto;
            height: 124px;
            width: 300px;
          }

          span {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #A52337;
            font-size: 56px;
          }
        }
      }

      .lottery-part {
        position: relative;
        padding: 40px 0;
        background: #F5F6F7;
        border-radius: 0 0 16px 16px;

        &.no-padding {
          padding: 0;
        }

        .lottery-btn {
          margin: 0 auto;
          background: linear-gradient(90deg, #F25757 0%, #A52337 100%);
          box-shadow: 0 24px 48px 0 rgba(255, 177, 177, 0.12);
          border-radius: 62px;
          width: 304px;
          height: 96px;
          display: flex;
          align-items: center;
          justify-content: center;

          &.disable {
            opacity: .6;
          }

          .text {
            font-size: 40px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 56px;
          }

          .icon {
            width: 44px;
            height: 44px;
          }
        }

        .bg-ticket {
          width: 100%;
          height: auto;
          border-radius: 0 0 16px 16px;
        }

        .ticket-code {
          position: absolute;
          left: 0;
          right: 0;
          top: 50%;
          text-align: center;
          height: 56px;
          font-size: 56px;
          font-family: "D-DIN-PRO-500-Medium";
          font-weight: 500;
          color: #A52337;
          line-height: 56px;

          &.normal {
            color: #A52337;
          }

          &.winning {
            top: 55%;
            color: #fff;
          }

          &.losing {
            top: 55%;
            color: #979797;
          }
        }
      }
    }

    .nolotteryCode {
      width: 100%;
      background: #F5F6F7;
      border-radius: 0 0 8px 8px;
      padding-bottom: 40px;

      .nolotteryCode-text {
        font-size: 32px;
        text-align: center;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #979797;
        padding: 24px 0;
        background-image: url("../../../assets/pointsActivity/onlottery-up.png");
        background-size: 100% 100%;
      }

      .nolotteryCode-cardbox {
        width: 100%;
        position: relative;

        img {
          display: block;
          margin: auto;
          height: 124px;
          width: 300px;
        }

        .nolotteryCode-num {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;

          .box {
            width: 100%;
            height: calc(100% - 24px);
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-flow: column;
            padding: 12px 0;

            .top {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #979797;
            }

            .num {
              font-size: 56px;
              font-family: "D-DIN-PRO-500-Medium";
              font-weight: 500;
              color: #979797;
            }
          }
        }
      }
    }

    .lottery {
      width: 100%;
      background: linear-gradient(to bottom, #fff, #FEEAE8, #FFDADA);
      border-radius: 0 0 8px 8px;
      padding-bottom: 40px;

      .lottery-text {
        font-size: 32px;
        text-align: center;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #A52337;
        padding: 24px 0;
        background-image: url("../../../assets/pointsActivity/lottery-up.png");
        background-size: 100% 100%;
      }

      .lottery-cardbox {
        width: 100%;
        position: relative;

        img {
          display: block;
          margin: auto;
          height: 124px;
          width: 440px;
        }

        .lottery-num {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;

          .box {
            width: 100%;
            height: calc(100% - 24px);
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-flow: column;
            padding: 12px 0;

            .top {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #fff;
            }

            .num {
              font-size: 56px;
              font-family: "D-DIN-PRO-500-Medium";
              font-weight: 500;
              color: #fff;
            }
          }
        }
      }
    }

    .history-list {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 96px;
      border-radius: 6px;
      margin-bottom: 24px;
    }

    .history-list:last-child {
      margin-bottom: 0;
    }

    .qualify {
      background: #F5F6F7;

      .history-data {
        display: flex;
        align-items: center;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A3B3C;

        img {
          width: 40px;
          height: 40px;
          margin: 0 16px 0 24px;
        }

        div {
          margin-top: 3px;
        }

      }

    }

    .no-qualify {
      background: #F9FAFA;

      .history-data {
        display: flex;
        align-items: center;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #909191;

        img {
          width: 40px;
          height: 40px;
          margin: 0 16px 0 24px;
        }

        div {
          margin-top: 3px;
        }

      }
    }
  }

  .lottery-ticket {
    width: 300px;
    height: 124px;
    margin: 0 auto 40px;
    background: url("~@/assets/pointsActivity/bg_ticket.png") no-repeat;
    background-size: 100% 100%;

    .code {
      padding-top: 18px;
      text-align: center;
      font-size: 56px;
      font-family: "D-DIN-PRO-500-Medium";
      font-weight: 500;
      color: #A52337;
      line-height: 56px;
    }
  }

  .lottery-Exchang {
    text-align: center;

    .top {
      display: flex;
      align-items: center;
      justify-content: center;

      div {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3A3B3C;
      }

      span {
        font-size: 36px;
        font-family: D-DIN-PRO-Medium, D-DIN-PRO;
        font-weight: 500;
        color: #A52337;
        margin-left: 8px;
      }

      img {
        width: 26px;
        height: 26px;
        margin: 0 4px;
      }
    }

    .down {
      color: #A52337;
      margin: 16px 0 24px 0;
    }
  }

}
</style>
